import React, { useRef } from 'react';
import { Form } from 'react-bootstrap-5';


export default function UserProfileToggle({ checked, label, name, onChange }: UserProfileToggleProps) {
  const id = useRef('user-' + Math.ceil(Math.random() * 1000000).toString());

  return (
    <div className="d-flex form-group">
      <Form.Check
        checked={checked}
        id={id.current}
        label={label}
        type="switch"
        onChange={onChange}
      />
      <input
        name={name}
        type="hidden"
        value={String(checked)}
      />
    </div>
  );
}

type UserProfileToggleProps = {
  checked: boolean;
  label: string;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};
